import './main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/css/common.scss'
createApp(App).use(ElementPlus).use(store).use(router).use(axios).mount('#app')